/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { useForm } from 'react-hook-form';

import 'react-datepicker/dist/react-datepicker.css';
import './EditBankDetailsModal.scss';
import { useDispatch } from 'react-redux';
import { uploadFile } from '../../store/modules/newUser/actions';

const EditUserModal = ({
  show, toggle, onSubmit, values,
}) => {
  const showHideClassName = show ? 'edit-user-modal display-block' : 'edit-user-modal display-none';
  const {
    register, handleSubmit, setValue, formState: { errors },
  } = useForm();
  const dispatch = useDispatch();
  const role = localStorage.getItem('role');
  const [uploadedFileUrl, setUploadedFileUrl] = useState(null);
  const [uploadError, setUploadError] = useState(null);
  useEffect(() => {
    if (values) {
      setValue('accountNumber', values?.accountNumber ?? values?.bankAccountNumber);
      setValue('bankName', values.bankName);
      setValue('branchName', values?.branchName);
      setValue('ifscCode', values?.ifscCode);
      setValue('branchCode', values?.branchCode);
      setUploadedFileUrl('bankPassbookUrl', values?.uploadedFileUrl);
      setValue('nameAsPerPassbook', values?.nameAsPerPassbook);
    }
  }, [setValue]);

  const handleFileUpload = async (event) => {
    event.preventDefault();
    const file = event.target.files[0];
    if (!file) return;
    try {
      setUploadError(null);
      const formData = new FormData();
      formData.append('file', file);
      const actionResult = await dispatch(uploadFile(formData));
      if (actionResult) {
        setUploadedFileUrl(actionResult);
        setValue('bankPassbookUrl', actionResult);
      }
    } catch (error) {
      console.error('Upload error:', error);
    }
  };

  const submit = async ({
    accountNumber,
    bankName,
    branchName,
    ifscCode,
    branchCode,
    nameAsPerPassbook,
    bankPassbookUrl,
  }) => {
    try {
      onSubmit({
        accountNumber,
        bankName,
        ifscCode,
        branchName,
        branchCode,
        bankPassbookUrl,
        nameAsPerPassbook,
      });
      toggle();
    } catch (error) {
      console.error('Error uploading file:', error);
    }
  };

  return (
    <div className={showHideClassName}>
      <section className="modal-main">
        <div className="row">
          <div className="col-12 d-flex end">
            <button type="button" className="modal-main__button" onClick={toggle}>
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
          <div className="col-12">
            <div className="form">
              <div className="row">
                <div className="col-12 col-md-6">
                  <div className="form__item">
                    <label htmlFor="frequency">
                      <div className="row middle">
                        <div className="col-12">
                          <span className="form__label">Bank Name</span>
                        </div>
                        <div className="col-12">
                          <input
                            className="form__field"
                            type="text"
                            id="bankName"
                            name="bankName"
                            placeholder="Bank Name"
                            {...register('bankName', { required: { value: false, message: 'Bank Name is required' } })}
                          />
                          {errors.bankName && <div className="form__error">{errors.bankName.message}</div>}
                        </div>
                      </div>
                    </label>
                  </div>
                  <div className="form__item">
                    <label htmlFor="frequency">
                      <div className="row middle">
                        <div className="col-12">
                          <span className="form__label">Branch Name</span>
                        </div>
                        <div className="col-12">
                          <input
                            className="form__field"
                            type="text"
                            id="branchName"
                            name="branchName"
                            placeholder="Branch Name"
                            {...register('branchName', { required: { value: false, message: 'Branch Name is required' } })}
                          />
                          {errors.branchName && <div className="form__error">{errors.branchName.message}</div>}
                        </div>
                      </div>
                    </label>
                  </div>
                  <div className="form__item">
                    <label htmlFor="frequency">
                      <div className="row middle">
                        <div className="col-12">
                          <span className="form__label">Branch Code</span>
                        </div>
                        <div className="col-12">
                          <input
                            className="form__field"
                            type="text"
                            id="branchCode"
                            name="branchCode"
                            placeholder="Branch Code"
                            {...register('branchCode', { required: { value: false, message: 'Branch Code is required' } })}
                          />
                          {errors.branchCode && <div className="form__error">{errors.branchCode.message}</div>}
                        </div>
                      </div>
                    </label>
                  </div>
                  {role === 'admin' && (
                    <div className="form__item">
                      <label htmlFor="frequency">
                        <div className="row middle">
                          <div className="col-12">
                            <span className="form__label">Capture Image</span>
                          </div>
                          <div className="col-12">
                            <input
                              className="form__field"
                              type="file"
                              accept="image/*"
                              id="bankPassbookUrl"
                              name="bankPassbookUrl"
                              onChange={handleFileUpload}
                            />
                            {uploadError && <div className="form__error">{uploadError}</div>}
                            {errors.bankPassbookUrl && (
                              <div className="form__error">{errors.bankPassbookUrl.message}</div>
                            )}
                          </div>
                        </div>
                      </label>
                    </div>
                  )}
                </div>
                <div className="col-12 col-md-6">
                  <div className="form__item">
                    <label htmlFor="frequency">
                      <div className="row middle">
                        <div className="col-12">
                          <span className="form__label">IFSC Code</span>
                        </div>
                        <div className="col-12">
                          <input
                            className="form__field"
                            type="text"
                            id="ifscCode"
                            name="ifscCode"
                            placeholder="IFSC Code"
                            {...register('ifscCode', { required: { value: false, message: 'IFSC Code is required' } })}
                          />
                          {errors.ifscCode && <div className="form__error">{errors.ifscCode.message}</div>}
                        </div>
                      </div>
                    </label>
                  </div>
                  <div className="form__item">
                    <label htmlFor="frequency">
                      <div className="row middle">
                        <div className="col-12">
                          <span className="form__label">Account Number</span>
                        </div>
                        <div className="col-12">
                          <input
                            className="form__field"
                            type="text"
                            id="accountNumber"
                            name="accountNumber"
                            placeholder="Account Number"
                            {...register('accountNumber', { required: { value: true, message: 'Account Number is required' } })}
                          />
                          {errors.accountNumber && <div className="form__error">{errors.accountNumber.message}</div>}
                        </div>
                      </div>
                    </label>
                  </div>
                  <div className="form__item">
                    <label htmlFor="frequency">
                      <div className="row middle">
                        <div className="col-12">
                          <span className="form__label">Name as per Passbook</span>
                        </div>
                        <div className="col-12">
                          <input
                            className="form__field"
                            type="text"
                            id="nameAsPerPassbook"
                            name="nameAsPerPassbook"
                            placeholder="Name as per Passbook"
                            {...register('nameAsPerPassbook', { required: { value: false, message: 'Name as per Passbook is required' } })}
                          />
                          {errors.nameAsPerPassbook && <div className="form__error">{errors.nameAsPerPassbook.message}</div>}
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
                <div className="col-12">
                  <div className="form__item">
                    <div className="row">
                      <div className="col-12 d-flex-col middle">
                        <button type="button" className="form__button" onClick={handleSubmit(submit)}>Save</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EditUserModal;
